import { Alert, Box, Button, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useStore } from './store'
import { ALERTS_ACTIONS } from './store/alerts'
import { Close } from '@mui/icons-material'

const ANIMATION_DURATION = 0.2
const DEFAULT_TIMEOUT = 3000

const AlertListener = () => {
  const {
    state: { alert },
    dispatch,
  } = useStore()

  const [timer, setTimer] = useState(null)
  const [animate, setAnimate] = useState(false)

  const removeAlert = () => {
    setAnimate(false)
    clearTimeout(timer)
    setTimeout(() => {
      dispatch({ type: ALERTS_ACTIONS.REMOVE_ALERT })
    }, ANIMATION_DURATION * 1000 + 100)
  }

  const createAlert = () => {
    clearTimeout(timer)
    setAnimate(false)

    if (!alert.close)
      setTimer(
        setTimeout(() => removeAlert(), alert.timeout || DEFAULT_TIMEOUT)
      )

    setTimeout(() => {
      setAnimate(true)
    }, 0)
  }

  useEffect(() => {
    clearTimeout(timer)
    if (alert) createAlert()
  }, [alert])

  if (!alert) return null

  return (
    <Box
      sx={{
        transition: `bottom ${ANIMATION_DURATION}s ease`,
        position: 'absolute',
        bottom: animate ? 'calc(50% - 32px)' : '-100px',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        zIndex: 99999,
        transform: 'scale(1.5)',
      }}
    >
      <Alert
        severity={alert.severity}
        variant={'filled'}
        onClose={removeAlert}
        action={
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {alert.action && (
              <Button
                variant={'outlined'}
                size={'small'}
                onClick={() => {
                  removeAlert()
                  alert.action.onClick()
                }}
              >
                {alert.action.label}
              </Button>
            )}

            {alert.close && (
              <IconButton
                sx={{ my: -1, mr: -1, color: 'white' }}
                onClick={() => removeAlert()}
              >
                <Close />
              </IconButton>
            )}
          </Box>
        }
      >
        {alert.message}
      </Alert>
    </Box>
  )
}

export default AlertListener
